<template>
  <div id="app">
    <header class="bg-blue-500 text-white p-4 flex justify-between items-center">
      <div class="text-lg font-bold">My App</div>
      <div class="relative">
        <button @click="toggleMenu" class="focus:outline-none">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"></path>
          </svg>
        </button>
        <div v-if="menuOpen" class="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20">
          <ul>
            <li v-for="item in menuItems" :key="item.name">
              <router-link :to="item.path" @click="toggleMenu" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </header>
    <router-view></router-view>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { provideEnums } from './composables/useEnums'


export default {
  name: 'App',
  data() {
    return {
      menuOpen: false,
      menuItems: [
        { name: 'Tasks', path: '/tasks' },
        { name: 'Items', path: '/items' },
        { name: 'Locations', path: '/locations' },
        { name: 'Stock', path: '/stock' }
      ]
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    }
  },

  setup() {
    const { fetchEnums } = provideEnums()

    onMounted(() => {
      fetchEnums()
    })
  }
}
</script>

<style>
/* Add your styles here */
</style>